module.exports = __webpack_public_path__ + "img/c4d8cd4.png";